import { useSlots as _useSlots, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "info-section-tile__wrapper" }
const _hoisted_2 = {
  key: 1,
  class: "info-section-tile__title"
}
const _hoisted_3 = {
  key: 2,
  class: "info-section-tile__subtitle"
}
const _hoisted_4 = { class: "info-section-tile__text" }

type Props = {
  title?: string;
  subtitle?: string;
  image?: string;
  text?: string;
  imageSize?: string | number;
}

type Slots = {
  title: string;
  subtitle: string;
  text: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoSectionTile',
  props: {
    title: {},
    subtitle: {},
    image: {},
    text: {},
    imageSize: { default: 50 }
  },
  setup(__props: any) {

const props = __props;

const slots = _useSlots();

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["info-section-tile", { 'info-section-tile--no-subtitle': !props.subtitle && !slots.subtitle }])
    }, [
      (props.image)
        ? (_openBlock(), _createBlock(_component_v_img, {
            key: 0,
            class: "info-section-tile__image",
            src: props.image,
            width: props.imageSize,
            height: props.imageSize
          }, null, 8, ["src", "width", "height"]))
        : _createCommentVNode("", true),
      (props.title || slots.title)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_2, [
            _renderSlot(_ctx.$slots, "title", {}, () => [
              _createTextVNode(_toDisplayString(props.title), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (props.subtitle || slots.subtitle)
        ? (_openBlock(), _createElementBlock("h5", _hoisted_3, [
            _renderSlot(_ctx.$slots, "subtitle", {}, () => [
              _createTextVNode(_toDisplayString(props.subtitle), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_4, [
        _renderSlot(_ctx.$slots, "text", {}, () => [
          _createTextVNode(_toDisplayString(props.text), 1)
        ])
      ])
    ], 2)
  ]))
}
}

})